// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import RankTier from "./rank_tier_type";


export default __t.row({
  id: __t.u64().primaryKey(),
  userId: __t.u64().name("user_id"),
  appliedAt: __t.u64().name("applied_at"),
  rpBefore: __t.i32().name("rp_before"),
  rpAfter: __t.i32().name("rp_after"),
  decayAmount: __t.i32().name("decay_amount"),
  get tier() {
    return RankTier;
  },
});
